export default {
  news: [],
};
